App.namespace.wrap('es6.views.venue.maps_callback', function () {
  // Street View and Map
  App.views.venue.location_venue_page();
});
